import { Button, Flex } from '@iheartjane/reefer';

type ScreenName =
  | 'sign-in'
  | 'create-account'
  | 'forgot-password'
  | 'new-success'
  | 'success'
  | 'confirmation';

interface SignInToggleButtonsProps {
  screen: ScreenName;
  setScreen: (screen: ScreenName) => void;
}

export const SignInToggleButtons = ({
  screen,
  setScreen,
}: SignInToggleButtonsProps) => {
  return (
    <Flex
      p={24}
      gap={16}
      flexDirection="row"
      width="100%"
      style={{ boxShadow: '0px -1px 0px 0px rgba(0, 0, 0, 0.10) inset' }}
    >
      <Button
        full
        size="small"
        variant={screen === 'sign-in' ? 'tertiary-selected' : 'tertiary'}
        label="Sign in"
        onClick={() => setScreen('sign-in')}
        data-testid="sign-in-toggle"
      />
      <Button
        full
        size="small"
        variant={screen === 'create-account' ? 'tertiary-selected' : 'tertiary'}
        label="Create account"
        onClick={() => setScreen('create-account')}
        data-testid="create-account-toggle"
      />
    </Flex>
  );
};
